import React from 'react';
import styled from 'styled-components';
import SectionHeading from '../common/SectionHeading';
import FAQ from '../common/FAQ';

const SectionContainer = styled.section`
  background-color: #161616;
  color: #FFFFFF;
  padding: 100px 0;
  
  @media (max-width: 768px) {
    padding: 80px 0;
  }
`;

const Content = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 0 24px;
`;

const FAQList = styled.div`
  margin-top: 60px;
`;

const FAQSection = () => {
  const faqs = [
    {
      question: "How does CarConsul help me buy a car?",
      answer: "CarConsul is an AI-powered assistant that helps you through every step of the car buying process. It researches vehicles based on your needs, compares options, reveals common issues and fair prices, provides negotiation strategies, and helps you avoid common car buying mistakes. All of this saves you time, money, and stress during your car purchase."
    },
    {
      question: "How much can I really save using CarConsul?",
      answer: "Our users save an average of $400-$500 on their car purchases. The savings come from knowing fair market prices, identifying potential issues before purchase, having effective negotiation strategies, and avoiding unnecessary add-ons. Some users have reported savings of over $1,000, especially on higher-priced vehicles or when avoiding problematic cars that would have led to expensive repairs."
    },
    {
      question: "Is CarConsul affiliated with any car dealerships?",
      answer: "Absolutely not. CarConsul is 100% independent and has no financial relationships with any dealerships, manufacturers, or other automotive companies. This allows us to provide completely unbiased advice that's solely in your best interest. Our only source of revenue is our subscription fees from users."
    },
    {
      question: "What are research credits and how do they work?",
      answer: "Research credits are used each time you conduct a detailed vehicle research session with CarConsul. One credit typically allows you to thoroughly research one specific vehicle model or compare multiple vehicles. Basic plans include 10 credits monthly, while premium plans offer 30 credits, giving you more flexibility to research multiple vehicles or dive deeper into specific models."
    },
    {
      question: "How is CarConsul different from other car research sites?",
      answer: "Unlike traditional car research sites that provide static information, CarConsul offers interactive, personalized guidance through AI conversation. We combine data from multiple sources into actionable insights, provide specific negotiation strategies, and focus on revealing information dealers don't want you to know. Plus, we're 100% independent with no dealer sponsorships influencing our recommendations."
    },
    {
      question: "Can CarConsul help with both new and used cars?",
      answer: "Yes! CarConsul provides comprehensive research and guidance for both new and used vehicles. For new cars, we focus on fair pricing, trim comparison, feature analysis, and negotiation strategies. For used cars, we add vehicle history insights, common issues at specific mileages, and market value analysis to ensure you don't overpay."
    },
    {
      question: "What if I need more credits than my plan allows?",
      answer: "If you need additional research credits beyond your monthly allocation, you can purchase extra credit packs without upgrading your subscription. These start at $5 for 5 additional credits. Alternatively, you can temporarily upgrade to a higher tier plan during months when you need more intensive research capabilities."
    },
    {
      question: "Is it a subscription?",
      answer: "No, you pay once and use. There is no subscription. We offer a 30-day money-back guarantee with no questions asked if you're not satisfied with the service."
    }
  ];

  return (
    <SectionContainer id="faqs">
      <Content>
        <SectionHeading 
          title="Frequently Asked Questions" 
          subtitle="Everything you need to know about CarConsul"
        />
        
        <FAQList>
          {faqs.map((faq, index) => (
            <FAQ 
              key={index}
              question={faq.question}
              answer={faq.answer}
            />
          ))}
        </FAQList>
      </Content>
    </SectionContainer>
  );
};

export default FAQSection;
